import { styled as MStyled } from '@mui/system'

export const styled = MStyled
